import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

/**
 * GET purchase orders
 * optional params can be added later (status, distributor_id etc.)
 */
export const getPurchaseOrders = createAsyncThunk(
  "purchaseOrder/getPurchaseOrders",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/purchase-orders/", {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch purchase orders!",
      );
    }
  },
);

export const getPOPayments = createAsyncThunk(
  "purchaseOrder/getPOPayments",
  async (id, { rejectWithValue }) => {
    // ← accept id
    try {
      const response = await axiosInstance.get(`/po-payments/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch payments!",
      );
    }
  },
);

export const createPOPayment = createAsyncThunk(
  "purchaseOrder/createPOPayment",
  async (payload, { rejectWithValue }) => {
    try {
      const hasFile = payload?.image instanceof File;
      let response;

      if (hasFile) {
        const formData = new FormData();
        formData.append("distributor", payload.distributor);
        formData.append("purchase_order", payload.purchase_order);
        formData.append("amount", payload.amount);
        formData.append("payment_date", payload.payment_date);
        if (payload.image) {
          formData.append("image", payload.image);
        }

        response = await axiosInstance.post("/po-payments/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axiosInstance.post("/po-payments/", payload);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create payment!",
      );
    }
  },
);

export const updatePaymentStatus = createAsyncThunk(
  "purchaseOrder/updatePaymentStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/po-payments/${id}/`, {
        status,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update payment status!",
      );
    }
  },
);
/**
 * CREATE purchase order
 */
export const createPurchaseOrder = createAsyncThunk(
  "purchaseOrder/createPurchaseOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/purchase-orders/", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create purchase order!",
      );
    }
  },
);

/**
 * UPDATE purchase order (PATCH)
 */
export const updatePurchaseOrder = createAsyncThunk(
  "purchaseOrder/updatePurchaseOrder",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/purchase-orders/${id}/`,
        data,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update purchase order!",
      );
    }
  },
);

/**
 * DELETE purchase order
 */
export const deletePurchaseOrder = createAsyncThunk(
  "purchaseOrder/deletePurchaseOrder",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/purchase-orders/${id}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete purchase order!",
      );
    }
  },
);
